<template>
  <div id="app" class="app" @click="isTimeOut">
    <headerTop v-show="!$route.meta.hideHeader"></headerTop>
    <div>
      <router-view v-if="isRouterAlive"></router-view>
    </div>

    <footerBtm v-show="!$route.meta.hideFooder"></footerBtm>

    <!-- ✅ 改动：后台页面隐藏在线咨询 -->
    <el-popover 
      v-show="!isAdminRoute"
      class="fixed" 
      placement="left-start" 
      title="" 
      width="250" 
      trigger="hover"
    >
      <div v-html="richText"></div>
      <div slot="reference">
        <div class="online" id="kuainiaoip">
          <img src="@/assets/img/cs.png" alt="">
          <span>在线咨询</span>
        </div>
      </div>
    </el-popover>

    <!-- 回顶按钮（如需后台也隐藏，同样加 v-show="!isAdminRoute"） -->
    <el-backtop :right="60" :bottom="302"></el-backtop>
  </div>
</template>

<script>
import headerTop from '@/components/headerTop.vue'
import footerBtm from '@/components/footerBtm.vue'

export default {
  name: 'app',
  components: {
    headerTop,
    footerBtm
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      richText: `<div class="link bot"></div>`,
      msg: '',
      gotop: false,
      isRouterAlive: true,
      lastTime: null,
      currentTime: null,
      timeOut: 1 * 30 * 60 * 1000
    }
  },
  // ✅ 新增：计算属性判断是否为后台路由
  computed: {
    isAdminRoute() {
      // 所有 /admin 开头的路由（含子页面）都判定为后台
      return this.$route.path.startsWith('/admin')
    }
  },
  created() {
    this.lastTime = new Date().getTime()
  },
  mounted() {
    const data = {
      id: 2
    }
    this.$apiFun.article(data).then(res => {
      console.log(res)
      if (res.code) {
        this.richText = res.data.content
      }
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    // 拉取QQ
    toQD() {
      window.open('https://wpa1.qq.com/WQx091qv?_type=wpa&qidian=true', '_blank')
    },
    // 超时自动关闭
    isTimeOut() {
      this.currentTime = new Date().getTime()
      if (this.currentTime - this.lastTime > this.timeOut) {
        if (sessionStorage.getItem('token')) {
          sessionStorage.removeItem('token')
          setTimeout(() => {
            this.$router.push('/')
            this.$alert('检测到您长时间未操作页面,请重新登录!', '温馨提示', {
              confirmButtonText: '确定',
              callback: (action) => {
                location.reload()
              }
            })
          }, 2000)
        } else {
          this.lastTime = new Date().getTime()
        }
      } else {
        this.lastTime = new Date().getTime()
      }
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    handleScroll() {
      const scrolltop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrolltop > 100) {
        this.gotop = true
      } else {
        this.gotop = false
      }
    },
    totop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    getUserInfo() {
      this.$apiFun.getUserInfo().then(res => {
        if (res.code == 1) {
          this.veri = res.data.certificationType
          sessionStorage.setItem('indet', res.data.certificationType)
        }
      })
    }
  },
  watch: {
    // 页面跳转后返回顶部
    $route(to) {
      document.getElementsByClassName('app')[0].scrollTop = 0
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.totop {
  position: fixed;
  bottom: 290px;
  right: 50px;
  z-index: 3;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.fixed {
  position: fixed;
  bottom: 360px;
  right: 50px;
  z-index: 3;
}

.online {
  color: #409eff;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #efefef;
  padding: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  cursor: pointer;
}

.online span {
  font-size: 12px;
}

.online:hover {
  background-color: #efefef;
}

.bot {
  border-bottom: 1px solid #efefef;
  align-items: center;
}

.link {
  display: flex;
  justify-content: flex-start;
  padding: 10px;
}

::v-deep .el-button {
  border: none;
}

.bg-purple-dark {
  margin-top: 100px;
}

.el-button:focus,
.el-button:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.square-backtop.el-backtop {
  border-radius: 2px;
  width: 64px;
  line-height: 64px;
  font-size: 24px;
}

.square-backtop .el-backtop__content {
  border-radius: 2px;
}

.el-container,
.el-main {
  background-color: transparent;
}

.btn-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  background-color: #fff;
  color: #606266;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;
}
.btn-link:hover {
  text-decoration: none;
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.btn-link:active {
  color: #3a8ee6;
  border-color: #3a8ee6;
}

.btn-link.btn-primary {
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
}
.btn-link.btn-primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}
.btn-link.btn-primary:active {
  background-color: #3a8ee6;
  border-color: #3a8ee6;
}

.btn-link.btn-success {
  background-color: #67c23a;
  border-color: #67c23a;
  color: #fff;
}
.btn-link.btn-success:hover {
  background-color: #85ce61;
  border-color: #85ce61;
  color: #fff;
}

.btn-link.is-plain {
  background-color: #fff;
}
.btn-link.btn-primary.is-plain {
  color: #409eff;
  background-color: #ecf5ff;
  border-color: #b3d8ff;
}
.btn-link.btn-primary.is-plain:hover {
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
}
.btn-link.btn-success.is-plain {
  color: #67c23a;
  background-color: #f0f9eb;
  border-color: #e1f3d8;
}
.btn-link.btn-success.is-plain:hover {
  background-color: #67c23a;
  border-color: #67c23a;
  color: #fff;
}
</style>
